import { safeDeleteSheet } from "@/lib/office-helpers";

const PROJECT5_SHEETS = ["Trimestre 1", "Trimestre 2"] as const;

const BLOG_CATEGORIES = [
  "Aperitivos",
  "Bebidas",
  "Panes y bollos",
  "Cazuelas",
  "Carnes",
  "Guarniciones",
  "Ensaladas",
  "Sopas",
];

const BLOG_DATA = [
  [33, 28, 19, 80],
  [1, 18, 4, 23],
  [2, 6, 5, 13],
  [14, 23, 17, 54],
  [3, 5, 9, 17],
  [10, 11, 21, 42],
  [7, 3, 10, 20],
  [30, 23, 18, 71],
];

function applyBlogTitle(sheet: Excel.Worksheet): void {
  const titleRange = sheet.getRange("A1:E1");
  titleRange.merge();
  // Set value on A1 only (merged range still reports 1x5 dimensions)
  sheet.getRange("A1").values = [["Registro de recetas"]];
  titleRange.format.font.name = "Comic Sans MS";
  titleRange.format.font.size = 28;
  titleRange.format.font.bold = true;
  titleRange.format.font.color = "#FF0000";
  titleRange.format.horizontalAlignment = "Left";
  sheet.getRange("1:1").format.rowHeight = 41;
}

export async function startProject15(): Promise<void> {
  await Excel.run(async (context) => {
    for (const sheetName of PROJECT5_SHEETS) {
      await safeDeleteSheet(context, sheetName);
    }

    const q1 = context.workbook.worksheets.add("Trimestre 1");
    const q2 = context.workbook.worksheets.add("Trimestre 2");

    applyBlogTitle(q1);
    applyBlogTitle(q2);

    q1.getRange("A:A").format.columnWidth = 145;
    q1.getRange("B:E").format.columnWidth = 84;
    q2.getRange("A:A").format.columnWidth = 145;
    q2.getRange("B:E").format.columnWidth = 84;

    const q1Table = q1.tables.add("A2:E2", true);
    q1Table.name = "T1_Asistencia";
    q1Table.getHeaderRowRange().values = [[
      "Entradas",
      "Enero",
      "Febrero",
      "Marzo",
      "Total",
    ]];
    for (let i = 0; i < BLOG_CATEGORIES.length; i++) {
      q1Table.rows.add(undefined, [
        [
          BLOG_CATEGORIES[i],
          BLOG_DATA[i][0],
          BLOG_DATA[i][1],
          BLOG_DATA[i][2],
          BLOG_DATA[i][3],
        ],
      ]);
    }
    q1Table.style = "TableStyleLight14";

    await context.sync();

    q1Table.columns.getItem("Total").getDataBodyRange().formulas = BLOG_DATA.map(
      (_, index) => [`=SUM(B${index + 3}:D${index + 3})`],
    );

    q1.getRange("B3:E10").numberFormat = Array(BLOG_DATA.length).fill([
      "#,##0",
      "#,##0",
      "#,##0",
      "#,##0",
    ]);
    q1.getRange("A12").values = [["Máximo"]];
    q1.getRange("A12").format.font.bold = true;
    q1.getRange("A12:E12").format.borders.getItem("EdgeTop").style = "Continuous";
    q1.getRange("A12:E12").format.borders.getItem("EdgeBottom").style = "Continuous";
    q1.getRange("A12:A12").format.borders.getItem("EdgeLeft").style = "Continuous";
    q1.getRange("E12:E12").format.borders.getItem("EdgeRight").style = "Continuous";
    q1.getRange("A12:E12").format.borders.getItem("EdgeTop").color = "#FF0000";
    q1.getRange("A12:E12").format.borders.getItem("EdgeBottom").color = "#FF0000";
    q1.getRange("A12:A12").format.borders.getItem("EdgeLeft").color = "#FF0000";
    q1.getRange("E12:E12").format.borders.getItem("EdgeRight").color = "#FF0000";

    const barChart = q1.charts.add(
      Excel.ChartType.barClustered,
      q1.getRange("A2:E10"),
      Excel.ChartSeriesBy.rows,
    );
    barChart.setPosition("F1", "M16");
    barChart.title.text = "Título del gráfico";
    barChart.legend.visible = true;
    barChart.style = 102;

    q2.getRange("A2:E2").values = [[
      "Entradas",
      "Enero",
      "Febrero",
      "Marzo",
      "Total",
    ]];
    q2.getRange("A3:A10").values = BLOG_CATEGORIES.map((category) => [category]);
    q2.getRange("A2:E10").format.font.name = "Corbel";
    q2.getRange("A2:E10").format.font.size = 14;

    q1.pageLayout.orientation = Excel.PageOrientation.landscape;
    q2.pageLayout.orientation = Excel.PageOrientation.landscape;

    q1.activate();
    q1.getRange("A1").select();

    await context.sync();
  });
}
